/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-template */

import React, {
    createContext,
    useContext,
    useState,
    useEffect,
} from 'react';

import { any } from 'prop-types';

const initialContext = {
    isScriptLoaded: false,
    setScriptLoaded: () => { },
};

const AccertifyContext = createContext(initialContext);

function AccertifyProvider({ children }) {
    const [isScriptLoaded, setScriptLoaded] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (document.querySelector('#accertify-script') && !isScriptLoaded) {
                setScriptLoaded(true);
            }
        }
    }, []);

    return (
        <AccertifyContext.Provider
            value={{
                isScriptLoaded,
                setScriptLoaded,
            }}
        >
            {children}
        </AccertifyContext.Provider>
    );
}

AccertifyProvider.propTypes = {
    children: any.isRequired,
};

function useAccertifyContext() {
    const context = useContext(AccertifyContext);
    return context;
}

export {
    AccertifyProvider,
    useAccertifyContext,
};
